<template>
  <div class="breadcrumb-bar breadcrumb-bar-info" style="padding: 60px 0 40px;">
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-12">
          <div class="breadcrumb-list">
            <h2 class="breadcrumb-title">{{ title }}</h2>
            <nav aria-label="breadcrumb" class="page-breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  {{ student }}
                </li>
                <!-- <li class="breadcrumb-item active" aria-current="page">{{ text1 }}</li> -->
              </ol>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    student: {
      type: String,
      default: "",
    },
    text1: {
      type: String,
      default: "",
    },
  },
};
</script>
